import { observer } from 'mobx-react-lite';

import { IcCloseIcon } from '@gem/icons';
import { AddKeyPressHandler } from '@gem/keyboard-handler';
import { useTranslation } from '@gem/modules/i18n';
import { IconButton } from '@gem/ui-kit';

import SaveArticleButton from './SaveArticleButton';
import usePresenter from './presenter';
import styles from './styles.m.css';

const Header = ({ core }) => {
  const presenter = usePresenter({ core });
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.leftBlock}>
        <IconButton
          className={styles.icon}
          Icon={IcCloseIcon}
          onClick={presenter.onCloseArticle}
          dataTest="close-button"
        />
        <AddKeyPressHandler onEsc={presenter.onCloseArticle} />
        <div className={styles.title}>
          {core.isEditMode ? t('channel_article_edit_article') : t('channel_new_article')}
        </div>
      </div>
      <div className={styles.rightBlock}>
        <SaveArticleButton parent={presenter} />
      </div>
    </div>
  );
};

export default observer(Header);
